import { render, staticRenderFns } from "./ReportGenerated.vue?vue&type=template&id=ca261182&"
import script from "./ReportGenerated.vue?vue&type=script&lang=js&"
export * from "./ReportGenerated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports